/* eslint-disable no-unused-vars */

//In the configuration file, you can use environment variables defined in the .env file.
// Make sure to prefix them with REACT_APP_.
//import config from '../config';
//{config.COMPANY_NAME}

  const url = window.location.href;
  const pathname = window.location.pathname;
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const webSiteOrigin = window.location.origin; //works
  const webSiteOriginArr = webSiteOrigin.split(':')
  
  //http://localhost:3000/
  //http://192.168.56.1:3000/

  let frontEndURLPort = ''
  let dashBoardURLPort = ''
  let environment = ''
  let backEndURL = ''
  
  if (webSiteOriginArr[1] === '//localhost' || webSiteOriginArr[1] === '//192.168.56.1') {
    frontEndURLPort = ":3000"
    dashBoardURLPort = ":3001"
    environment = 'Dev'
    backEndURL = webSiteOriginArr[0] + ":" + webSiteOriginArr[1] + ":5000"
  } else {
    frontEndURLPort = ""
    dashBoardURLPort = ""
    environment = 'Prod'

    // comments and instructions are in the config.js file in the dashboard

    //google cloud run
    backEndURL = "https://kosher-caterer-backend-315207846397.us-central1.run.app"
    
    //railway
    //backEndURL = "https://kosher-caterer-backend-production-8394.up.railway.app" //abby.berry@inbox.lv
    //used emails: yzidell2@hotail.com abigail.bahar@inbox.lv abby.miller@myinvitationlabels.com abigail.baron2@inbox.lv

    //render.com
    //backEndURL = "https://kosher-caterer-backend-api.onrender.com"
    
    //azure web app
    //backEndURL = "https://wa-kosher-caterer-backend-gcbbg4eahwesb2dc.eastus-01.azurewebsites.net"

    //azure old delete
    //kosher-caterer-backend-dmd2aeaxbwfge0c5.westcentralus-01.azurewebsites.net

    //vercel
    //backEndURL = "https://kosher-caterer-backend.vercel.app"

  }
  
  const frontEndURL = webSiteOriginArr[0] + ":" + webSiteOriginArr[1] + frontEndURLPort // ":3000"
  const dashBoardURL = webSiteOriginArr[0] + ":" + webSiteOriginArr[1] +  dashBoardURLPort // ":3001"
  
  //const backEndURL = webSiteOriginArr[0] + ":" + webSiteOriginArr[1] +  backEndURLPort //":5000"

    // const backEndURLProd = webSiteOriginArr[0] + ":" + webSiteOriginArr[1] +  ":6000"
    //const domain =  window.location.domain
    
    //   return (
    //     <div>
    //       You are currently accessing <b>{url}</b><br />
    //       Pathname: <b>{pathname}</b><br />
    //       Protocol: <b>{protocol}</b><br />
    //       Hostname: <b>{hostname}</b>
    //     </div>
    //   );
    // }
    
    // immediate function
    //CREATE DEAFULT VALUES WHEN NEW SELLER REGISTERS
    //const {sellerId} = useSelector(state => state.seller)
    
  // from homereducer
  //   export const get_category = createAsyncThunk(
  //     'product/get_category',
  //     async(webSiteOrigin, { fulfillWithValue }) => {
    //async(info no brackets
  //         try {
  //             //const {data} = await api.get(`/products-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,{withCredentials: true}) 
  //             //const {data} = await api.get('/home/get-categorys')
  //             const {data} = await api.get(`/home/get-categorys?webSiteOrigin=${encodeURIComponent(webSiteOrigin)}`)
  //             //console.log('homeReducer /home/get-categorys')
  //             //console.log(data)
  //             return fulfillWithValue(data)
  //         } catch (error) {
  //             console.log(error.response)
  //         }
  //     }
  // )
  // // End Method

  //dispatch(admin_order_status_update({orderId, info: {status: e.target.value} }))
  
    //const Chat = () => {
    //const config = () => {
    const config = {

        //apiUrl: process.env.REACT_APP_API_URL || 'https://api.example.com',
        //otherVariable: process.env.REACT_APP_OTHER_VARIABLE || 'defaultValue',
        //http://localhost:3000/images/kosher-catering.png
        //process.env.REACT_APP_COMPANY_NAME ||  process.env.REACT_APP_COMPANY_LOGO3 || process.env.REACT_APP_COMPANY_LOGO || 
        //process.env.REACT_APP_PRODUCT_TERM || process.env.REACT_APP_SHOW_PAYMENTS || process.env.REACT_APP_SHOW_CATEGORY_IMAGES ||
        //process.env.REACT_APP_SHOW_INGREDIENTS_IMAGES ||
        STR_FRONTEND_URL: frontEndURL, 
        STR_DASHBOARD_URL: dashBoardURL,
        STR_BACKEND_URL: backEndURL,
        STR_ENVIRONMENT: environment,
        //STR_BACKEND_URL_PROD: backEndURLProd,

        //configure site functionality
        //config.
        
        //for seller dashboard
        //BOOL_CHAT_ONLINE: true,
        //static not in database
        BOOL_SHOW_PRODUCT_STOCK: false, 
        BOOL_SHOW_PRODUCT_OUT_OF_STOCK: false, 
        BOOL_SHOW_PRODUCT_BRAND: false, 
        BOOL_SHOW_PRODUCT_DISCOUNT: false,  
      
        INT_FRONTEND_PRICE_RANGE_STEP: 1,

        STR_FRONTEND_REQUIRED_FIELD_COLOR: '#c8894a',
        
        // STR_ARR_FRONTEND_EVENT_TYPES: ['Birthday', 'Anniversary', 'Engagement','Wedding','Bar Mitzvah','Bat Mitzvah',
        //   'Bris','Friday Night Dinner', 'Corporate Event', 'Shaboss Kiddush','Shaboss Kiddush + Luncheon','Shabbos Luncheon'],
        
        STR_ARR_PRODUCT_FMP: ['Fleishig-Meat', 'Milchig-Dairy','Pareve','Pareve-Meat-Utensils','Pareve-Dairy-Utensils'],
        STR_ARR_PRODUCT_ALLERGIES: ['None', 'Eggs','Milk', 'Fish', 'Nuts','Wheat','Soybeans'],

        STR_ARR_FLOOR_PLANNER_CANVAS_SIZES: ['400', '500', '600', '700', '800', '900', '1000', '1100', '1200', '1300', 
          '1400', '1500', '1600', '1700', '1800', '1900', '2000'],
        STR_ARR_FLOOR_PLANNER_ROOM_SIZES: ['10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', 
          '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
          '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60',
          '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80',
          '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '100',
          '105', '110', '115', '120', '125', '130', '135', '140', '145', '150', '155', '160', '165', '170', '175', '180', '185',
          '190', '195', '200', '205', '210', '215', '220', '225', '230', '235', '240', '245', '250', '255', '260', '265', '270',
          '275', '280', '285', '290', '295', '300', '305', '310', '315', '320', '325', '330', '335', '340', '345', '350', '355',
          '360', '365', '370', '375', '380', '385', '390', '395', '400', '405', '410', '415', '420', '425', '430', '435', '440',
          '445', '450', '455', '460', '465', '470', '475', '480', '485', '490', '495', '500', '505', '510', '515', '520', '525',
          '530', '535', '540', '545', '550', '555', '560', '565', '570', '575', '580', '585', '590', '595', '600', '605', '610',
          '615', '620', '625', '630', '635', '640', '645', '650', '655', '660', '665', '670', '675', '680', '685', '690', '695',
          '700'
        ],
        
          // '400', '500', '600', '700', '800', '900', '1000', '1100', '1200', '1300', 
          // '1400', '1500', '1600', '1700', '1800', '1900', '2000'

        STR_ARR_MESSAGING_PREFERENCES: [
            { id: 'Phone', name: 'Phone' },
            { id: 'Email', name: 'Email' },
            { id: 'SMSText', name: 'SMSText' },
            //{ id: 'WhatsApp', name: 'WhatsApp' }
        ]   
      };
      
//Hex Opacity strings for reference when you want to add opacity to a hex color code. For example, if your primary color is #0c6bf2 and you want to use it with 50% opacity, you would use #0c6bf280.
  // FF 100%, E6 90%, CC 80%, B3 70%, 99 60%, 80 50%, 
  // 66 40%, 4D 30%, 40 25%, 33 20%, 22 13%, 1A 10%, 11 7%

    export default config;
    
    //config.STR_FRONTEND_PRIMARY_COLOR1
        // STR_FRONTEND_PRIMARY_COLOR1: '#0c6bf2',  //#0c6bf2 blue  #059473 green #7a2757 #FF0000 red #0cf264 light green
        // STR_FRONTEND_PRIMARY_COLOR2: '#475569',  //#475569 slate, 370839e medium slate, #0c6bf2, blue #ff0000 red, #0cf264 bright green
        // STR_FRONTEND_SECONDARY_COLOR1: '#ede8f5', //# light pruple
        // STR_FRONTEND_SECONDARY_COLOR2: '', //
        //STR_ARR_FRONTEND_CLOTH_COLORS: ['White','Black','Grey','Navy','Aqua','Pink','Purple', 'Red', 'Green'],
        
        //STR_FRONTEND_TEXT_COLOR1: '#FFFFFF', //
        //STR_FRONTEND_TEXT_COLOR2: '', //
        //STR_FRONTEND_BODY_TEXT_COLOR1: '#000000', //
        //STR_FRONTEND_BODY_TEXT_COLOR2: '', //
        //STR_COMPANY_LOGO2: webSiteOrigin + '/images/kosher-catering.png',
        //STR_COMPANY_NAME: 'Kosher Catering', //shopName in code and database
        //STR_STRIPE_TEST_PUBLISHABLE_KEY: 'pk_test_Wa6x5crPoL7vFLPpKZwVakMP',
        //STR_STRIPE_TEST_SECRET_KEY: 'sk_test_ZkCPHupxTujQ2DCaFePY9mSA',
        //STR_COMPANY_PHONE: '(212) 555-1212',
        //STR_COMPANY_EMAIL: 'someone@gmail.com',
        //STR_MARKETING_LINE1: 'We Cook Everything Fresh, From Scratch, With Love And Care For Your Simcha/Party',
        //STR_BEFORE_YOU_REGISTER: 'Please Contact Us To Make Sure That We Can Cater Your Simcha/Party',
        //STR_FRONTEND_TAGLINE_TOP: 'Craft Your Own Menu For Your Next Simcha',
        //STR_FRONTEND_TAGLINE_MAIN: 'Kosher Caterer - Craft Your Very Own Menu',
        //STR_SHOPPING_TERM: 'My Menu',
        //STR_MAIN_INGREDIENT_TERM: 'Primary Ingredient',
        //STR_MAIN_INGREDIENT_TERM_PLURAL: 'Primary Ingredients',
        //STR_PRODUCT_TERM: 'Menu Item',
        //STR_PRODUCT_TERM_PLURAL: 'Menu Items',
        //BOOL_SHOW_FRONTEND_LATEST_PRODUCTS: true, //removed
        //BOOL_SHOW_FRONTEND_TOP_RATED_PRODUCTS: true, //removed
        //BOOL_SHOW_FRONTEND_DISCOUNT_PRODUCTS: true, //removed
        
        //home page features
        //BOOL_SHOW_HOMEPAGE_BANNER: false,
        //BOOL_SHOW_HOMEPAGE_CATEGORIES_TOP: false,
        //BOOL_SHOW_HOMEPAGE_CATEGORIES_BOTTOM: false,
        //BOOL_SHOW_HOMEPAGE_MAIN_INGREDIENTS_TOP: false,
        //BOOL_SHOW_HOMEPAGE_MAIN_INGREDIENTS_BOTTOM: false,
        //BOOL_SHOW_HOMEPAGE_FAVORITE_PRODUCTS: true,
        //BOOL_SHOW_HOMEPAGE_THREE_PRODUCT_COLUMNS: true,

        // STR_ARR_SAMPLE_MENU_DISPLAY_NAMES: ['Bar_Bas_Mitzvah', 'Bris', 'Shabbos_Kiddush', 'Shabbos_Dinner'],

        // STR_ARR_SAMPLE_MENU_FILE_NAMES: ['Kosher_Catering_Meat_Bar_Bas_Mitzvah_Sample_Menu.pdf', 
        //   'Kosher_Catering_Meat_Bris_Sample_Menu.pdf', 'Kosher_Catering_Meat_Shabbos_Kiddush_Sample_Menu.pdf',
        //   'Kosher_Catering_Meat_Shabbos_Dinner_Sample_Menu.pdf'],

        //move to seller profile
        //STR_ARR_FRONTEND_SERVICE_TYPES: ['Drop Off','Buffet Style', 'Full Service Plated Waiter Served'],
        //STR_ARR_FRONTEND_PLACE_SETTINGS: ['China Tableware','High Quality Plastic Tableware'],
        //buffet style with guest tables set or not set

        //removed
        //BOOL_SHOW_CATEGORIES_IMAGES: true, 
        //BOOL_SHOW_MAIN_INGREDIENTS_IMAGES: true, 
        //BOOL_SHOW_SHOP_PAGE_LATEST_PRODUCTS:true,
        //BOOL_SHOW_PAYMENTS: true, 
        //BOOL_SHOW_SOCIAL_MEDIA: false, 
        //BOOL_SHOW_WISHLIST: true, 
        //BOOL_SHOW_FRONTEND_RATING: true,
        //BOOL_SHOW_FRONTEND_PRODUCT_QUANTITIES: true,
        //BOOL_SHOW_FRONTEND_COOKING_METHODS: true,
        //BOOL_SHOW_FRONTEND_DISCOUNT_PRODUCTS_UNDER_FILTER: true,
      
        //BOOL_SHOW_PRODUCT_REVIEWS: true, 
        //BOOL_SHOW_SELLER_PACKAGES: true,
        //BOOL_SHOW_SELLER_SAMPLE_MENUS: true,
        //BOOL_SHOW_CHAT: true, 
      //STR_DEPOSIT: '500',
                                


